"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
var react_1 = __importDefault(require("react"));
var BaseInput_1 = require("./common/BaseInput");
function TextInput(_a) {
    var onChange = _a.onChange, placeholder = _a.placeholder, size = _a.size, value = _a.value;
    return (react_1.default.createElement(BaseInput_1.BaseInputWrapper, { size: size },
        react_1.default.createElement(BaseInput_1.BaseInput, { onChange: onChange, placeholder: placeholder, type: 'text', value: value })));
}
exports.TextInput = TextInput;
